import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackBank } from './tracking';
import { BankList } from '../../components/BankList';
import { selectPage } from '../../selectors/analytics';
import { selectBanks } from '../../selectors/promosPage';
import { IBank } from '../../types/promosPage';

export const BankListContainer: React.FC<{}> = () => {
  const bankList = useSelector(selectBanks);
  const page = useSelector(selectPage);

  const handleViewedAction = React.useCallback(
    (position: number, bank: IBank) => {
      trackBank({ action: 'show_sopr', position, bank, page });
    },
    [page],
  );

  const handleClick = React.useCallback(
    (position: number, bank: IBank) => {
      trackBank({ action: 'Click', position, bank, page });
    },
    [page],
  );

  if (bankList.length === 0) {
    return null;
  }

  return <BankList banks={bankList} onCardView={handleViewedAction} onCardClick={handleClick} />;
};
